<template>
    <div>        

        <Breadcrumbs main="Master" title="Plot Siswa"/>

        <!-- bulk upload modal -->
        <b-modal id="bulk-upload-modal" title="Bulk Upload Data Plot Walikelas" hide-footer>
            <div style="display:flex; justify-content:space-between; align-items:center; width : 320px;" class="mb-2">
                <b-button @click="downloadFormat" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                    Unduh Data
                </b-button>
                <input type="file" @change="handleChange" />
                <b-button v-if="bulkUpdate.length" @click="uploadExcel" variant="success" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                    Unggah Data
                </b-button>
            </div>
        </b-modal>

        <!-- add modal -->
        <b-modal id="add-modal" title="Tambah Data Siswa Kelas" hide-footer>
            <b-form class="needs-validation" @submit.prevent="handleSubmit">
                <div class="card-body">
                    <!-- mulai form siswa -->
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Nama Siswa</label>
                                <b-form-select v-model="selectedSiswa" class="mb-3">
                                    <b-form-select-option :value="null">Silahkan Pilih Nama Siswa</b-form-select-option>
                                    <b-form-select-option :value="val.id" v-for="(val) in allSiswabyTenant" :key="val.id">{{ val.nama }}</b-form-select-option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Nama Walikelas</label>
                                <b-form-select v-model="selectedWaliKelas" class="mb-3">
                                    <b-form-select-option :value="null">Silahkan Pilih Nama Walikelas</b-form-select-option>
                                    <b-form-select-option :value="val.id" v-for="val in dataUserWaliKelas" :key="val.id">{{ val.User.nama_lengkap }} - {{ val.Kelas.nama }}</b-form-select-option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>
                    <!-- end form siswa -->                                                                
                </div>

                <div>
                    <b-button type="submit" variant="primary" class="mr-1">Submit</b-button>                                
                    <b-button type="reset" variant="danger" @click="cancelAdd">Cancel</b-button>
                </div>
            </b-form>
        </b-modal>

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row" v-if="stateCondition == 0">
                <div class="col-md-12">
					<div class="card">
						<div class="card-header">
							<h5 class="card-title">Tahun Ajaran Masih Kosong</h5>
						</div>
						<div class="card-body">
                            <div style="display:flex; justify-content:space-between; align-items:flex-start; width : 50%; flex-direction:column" class="mb-2">
                                <h6>Maaf anda belum mengisi periode tahun ajaran, silahkan isi periode tahun ajaran terlebih dahulu !!</h6>
                            </div>
						</div>
                        <div class="card-footer">
                            <b-button @click="backToPeriode" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                Kembali
                            </b-button>
                        </div>
					</div>
				</div>
            </div> 
            <!-- list table siswa -->
            <div class="row" v-else>
                <div class="col-md-12">
					<div class="card">
						<div class="card-header" style="display:flex; justify-content:space-between;">
							<h5 class="card-title">Daftar Siswa</h5>
                            <!-- <b-button @click="changeState(0)" variant="dark" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                <feather type="arrow-left" stroke="white"></feather> Kembali
                            </b-button> -->
						</div>
						<div class="card-body">
                            <div style="display:flex; justify-content:space-between; align-items:center; width : 320px;" class="mb-2">
                                <b-button @click="addData" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="plus" stroke="white"></feather> Tambah Data
                                </b-button>
                                <b-button @click="downloadDataWalikelas" variant="danger" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="plus" stroke="white"></feather> Data Walikelas
                                </b-button>
                                <b-button @click="downloadDataSiswa" variant="danger" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="plus" stroke="white"></feather> Data Siswa
                                </b-button>
                                <b-button @click="addBulkData" variant="success" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="plus" stroke="white"></feather> Impor Data
                                </b-button>
                            </div>
							<div class="table-responsive datatable-vue m-0 vue-smart">
                                <div style="margin:10px 0px 10px 0px;" class="row">
                                    <div class="col-3">
                                        <label style="font-size:13px;">Cari Berdasarkan NIS Siswa:</label>
                                        <input class="form-control" v-model="filters.siswa.value.nis"/>
                                    </div>
                                    <div class="col-3">
                                        <label style="font-size:13px;">Cari Berdasarkan Nama Siswa:</label>
                                        <input class="form-control" v-model="filters.siswa.value.nama_siswa"/>
                                    </div>
                                    <div class="col-3">
                                        <label style="font-size:13px;">Cari Berdasarkan Kelas:</label>
                                        <input class="form-control" v-model="filters.siswa.value.kelas"/>
                                    </div>
                                    <div class="col-3">
                                        <label style="font-size:13px;">Cari Berdasarkan Walikelas:</label>
                                        <input class="form-control" v-model="filters.siswa.value.walikelas"/>
                                    </div>
                                </div>
                                
								<v-table
										:data="allWalikelas" class="table"
                                        :filters="filters"
										:currentPage.sync="basic.currentPage"
										:pageSize="50"
										@totalPagesChanged="basic.totalPages = $event"
								>
									<thead slot="head">
                                        <v-th>No</v-th>
                                        <v-th sortKey="nis">NIS</v-th>
                                        <v-th sortKey="nama_siswa">Nama Siswa</v-th>
                                        <v-th >Kelas</v-th>
                                        <v-th >Nama Walikelas</v-th>
                                        <v-th>Action</v-th>
									</thead>
									<tbody slot="body" slot-scope="{displayData}">
									<tr v-for="(row, index) in displayData" :key="row.id">
										<td>{{ index + 1 }}</td>										
										<td>{{ row.nis }}</td>                                        
										<td>{{ row.nama_siswa }}</td>
										<td>{{ row.nama_kelas }}</td>
                                        <td v-if="index === indexEdit">
                                            <b-form-select v-model="form_data.idwalikelas" class="mb-3">
                                                <b-form-select-option :value="val.id" v-for="val in dataUserWaliKelas" :key="val.id">{{ val.User.nama_lengkap }} - {{ val.Kelas.nama }}</b-form-select-option>
                                            </b-form-select>
                                        </td>
										<td v-else>{{ row.nama_walikelas }}</td>

										<td>
                                            <div v-if="index === indexEdit" style="display:flex; justify-content:space-between; align-items:center; width:60px;">
                                                <feather style="cursor:pointer;" type="save" stroke="blue" @click="saveData(row)"></feather>
                                                <feather style="cursor:pointer;" type="x" stroke="red" @click="resetForm"></feather>
                                            </div>
                                            <div v-else style="display:flex; justify-content:space-between; align-items:center; width:60px;">
                                                <feather style="cursor:pointer;" type="edit-2" stroke="blue" @click="editData(row, index)"></feather>
                                                <feather style="cursor:pointer;" type="trash-2" stroke="red" @click="deleteData(row)"></feather>
                                            </div>
                                        </td>										
									</tr>
									</tbody>
								</v-table>

								<smart-pagination
										:currentPage.sync="basic.currentPage"
										:totalPages="basic.totalPages"
								/>
							</div>
						</div>
					</div>
				</div>
            </div>      
        </div>
        <!-- Container-fluid Ends-->
        <div class="loader" v-if="loader"></div>
    </div>
</template>

<script>
    //import datakelas from '../../data/kelas'
    import {url} from "@/urls";
    import {service} from '@/services';
    import * as _ from 'underscore';    
    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';

    export default {
        data(){
            return{
                bulkUpdate:[],
                tenant: localStorage.getItem("idtenant"),
                filters: {
                    siswa: { value: { nis: '', nama_siswa: '', kelas: '', walikelas: '' }, custom: this.plotSiswaFilter }
                },
                stateCondition:0,   //0 pilih periode, 1 masuk tampilan
                indexEdit:-1,
                allWalikelas: [],
                allPeriode: [],
                allSiswabyTenant: [],
                dataUserWaliKelas: [],
                selectedPeriodeSiswa:0,
                selectedSiswa:null,
                selectedPeriode:null,
                selectedWaliKelas:null,
                form_data:{
                    idtenant: localStorage.getItem("idtenant"),
                    idsiswa:  "",
                    idwalikelas: "",
                },
                form_data_result:{
                    idperiode:null,
                    idsiswa:null,
                    idwalikelas:null
                },
                loader:false,

                basic:{
                    currentPage: 1,
                    totalPages: 0,
			    }
            }
        },
        methods: {
            plotSiswaFilter(filterValue, row) {
                if (filterValue.nis && !filterValue.nama_siswa && !filterValue.kelas && !filterValue.walikelas) {
                    return row.nis.toLowerCase().includes(filterValue.nis.toLowerCase())
                } else if(filterValue.nama_siswa && !filterValue.nis && !filterValue.kelas && !filterValue.walikelas) {
                    return row.nama_siswa.toLowerCase().includes(filterValue.nama_siswa.toLowerCase())
                } else if(filterValue.kelas && !filterValue.nis && !filterValue.nama_siswa && !filterValue.walikelas) {
                    return row.nama_kelas.toLowerCase().includes(filterValue.kelas.toLowerCase())
                } else if(filterValue.walikelas && !filterValue.nis && !filterValue.kelas && !filterValue.nama_siswa) {
                    return row.nama_walikelas.toLowerCase().includes(filterValue.walikelas.toLowerCase())
                } else if(filterValue.nama_siswa && filterValue.nis && filterValue.kelas && filterValue.walikelas) {
                    return row.nama_siswa.toLowerCase().includes(filterValue.nama_siswa.toLowerCase()) && row.nis.toLowerCase().includes(filterValue.nis.toLowerCase()) && row.nama_kelas.toLowerCase().includes(filterValue.kelas.toLowerCase()) && row.nama_walikelas.toLowerCase().includes(filterValue.walikelas.toLowerCase())
                } else {
                    return row
                }
            },
            backToPeriode() {
                this.$router.push({
                    path: '/master/periode',
                    // query: { type: 2 },
                });
            },

            // onChangeWalikelas(data) {
            //     this.form_data.iduser = data
            //     console.log(this.form_data.iduser)
            // },
            // onChangeKelas(data) {
            //     this.form_data.idkelas = data
            //     console.log(this.form_data.idkelas)
            // },
            // onChangePeriode(data) {
            //     this.form_data.idperiode = data
            //     console.log(this.form_data.idperiode)
            // },
            cancelAdd() {
                this.$bvModal.hide('add-modal')
                this.resetForm()
            },
            addBulkData() {
                this.$bvModal.show('bulk-upload-modal')
            },
            uploadExcel() {
                this.loader = true
                if (this.bulkUpdate.length) {
                    // console.log(this.bulkUpdate, 'bulk')
                    service.onPost(`${url.plot_siswa_bulk_upload}`, this.bulkUpdate)
                    .then((res) => {
                        console.log(res.data)
                        if (res.status == 200) {
                            setTimeout(() => {
                                this.loader = false;
                                this.$toasted.show(" Data plot siswa berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                            }, 1000);                            
                            this.getAllSiswaByPeriode()
                            this.resetForm()
                            this.bulkUpdate = []
                            this.$bvModal.hide('bulk-upload-modal')
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$toasted.show(" Terjadi kesalahan input, pastikan data yang diupload sesuai dengan format data ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        this.loader = false;
                        this.resetForm()
                        this.bulkUpdate = []
                        this.$bvModal.hide('bulk-upload-modal')
                    })
                }
                // console.log(this.bulkUpdate)
            },
            async downloadFormat() {
                const wb = new ExcelJS.Workbook();
                const ws = wb.addWorksheet('My Worksheet');
                
                const Header = [
                    "No", 
                    "Nama Siswa", 
                    "ID Siswa*",
                    "Nama Kelas", 
                    "ID Walikelas*", 
                ]

                ws.getRow(1).values=Header
                ws.getRow(1).font={bold: true}
                ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };                
    
                const buf = await wb.xlsx.writeBuffer()

                saveAs(new Blob([buf]), 'Format_Unggah_Data_Plot_Siswa.xlsx')
                this.$bvModal.hide('bulk-upload-modal')

            },
            handleChange(e) {
                this.file = e.target.files[0]
                this.handleImport()
            },
            handleImport() {
                const wb = new ExcelJS.Workbook();
                const reader = new FileReader()
                let obj = {}
                let body = []

                reader.readAsArrayBuffer(this.file)
                reader.onload = () => {
                    const buffer = reader.result;
                    wb.xlsx.load(buffer).then(workbook => {
                        // console.log(workbook, 'workbook instance')
                        workbook.eachSheet((sheet, id) => {
                            for (let index = 1; index < sheet._rows.length; index++) {
                                console.log(sheet._rows[index], sheet._rows.length)
                                if (sheet._rows[index].hasValues) {
                                    obj['idtenant'] = localStorage.getItem('idtenant')
                                    obj['idsiswa'] = sheet._rows[index].values[3]
                                    obj['idwalikelas'] = sheet._rows[index].values[5]
                                    body.push(obj)
                                    obj={}
                                }                                                            
                            }
                        })
                        this.bulkUpdate = body
                        console.log(body)
                    })
                }
            },
            async downloadDataSiswa() {                
                const wb = new ExcelJS.Workbook();
                const ws = wb.addWorksheet('My Worksheet');
                
                const Header = [
                    "No", 
                    "NIS",
                    "Nama Siswa*", 
                    "ID Siswa"                     
                ]

                ws.getRow(1).values=Header
                ws.getRow(1).font={bold: true}
                ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

                this.allSiswabyTenant.forEach((item, index) => {
                    let row = ws.addRow([
                        index+1,
                        item.nis,
                        item.nama,
                        item.id
                    ])
                })

                const buf = await wb.xlsx.writeBuffer()

                saveAs(new Blob([buf]), 'Data_Siswa.xlsx')                
            },
            async downloadDataWalikelas() {                
                console.log("DATA WALI", this.dataUserWaliKelas);
                const wb = new ExcelJS.Workbook();
                const ws = wb.addWorksheet('My Worksheet');
                
                const Header = [
                    "No", 
                    "Kelas",
                    "Nama Walikelas*", 
                    "ID walikelas"                  
                ]

                ws.getRow(1).values=Header
                ws.getRow(1).font={bold: true}
                ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

                this.dataUserWaliKelas.forEach((item, index) => {
                    let row = ws.addRow([
                        index+1,
                        item.Kelas.nama,
                        item.User.nama_lengkap,
                        item.id
                    ])
                })

                const buf = await wb.xlsx.writeBuffer()

                saveAs(new Blob([buf]), 'Data_Plot_Walikelas.xlsx')                
            },
            addData() {                
                this.$bvModal.show('add-modal')
            },
            changeState(state) {
                this.$data.stateCondition = state
            },
            saveData(data) {
                 console.log(data, 'save')
                // console.log(this.$data.form_data, 'save')
                this.loader = true;
                this.form_data.idtenant = localStorage.getItem("idtenant")
                // this.form_data.idtenant = this.tenant
                let body = {
                    idsiswa: this.form_data.idsiswa,
                    idwalikelas: this.form_data.idwalikelas
                }
                console.log(body, 'save')
                service.onUpdate(`${url.siswakelas}/${data.id}`, body)
                .then(result => {
                    setTimeout(() => {
                        this.loader = false;
                        this.$toasted.show(" Siswa berhasil diubah ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                    }, 1000);                        
                    console.log("result save", result.data);
                    this.getAllSiswaByPeriode()
                    this.resetForm()
                    // this.cancelAdd()					
                }).catch(error => {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        console.log(error);
                        this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        this.loader = false;
                    }, 1000);
                    // this.cancelAdd()
                    this.resetForm()
                })
            },
            deleteData(data) {
                this.$swal({
                    icon: 'warning',
                    title: `Apakah anda yakin`,
                    text : `ingin menghapus data ${data.nama_siswa} ?`,
                    showCancelButton: true,
                    cancelButtonText: `Tidak`,
                    confirmButtonText: `Ya`,
                }).then((res) => {
                    // console.log(this.getId(data.idtenant))
                    if (res.isConfirmed) {
                        let body = { 
                            idtenant: this.tenant,
                            idsiswa: data.idsiswa,
                            idwalikelas: data.idwalikelas
                        }
                        console.log(body);

                        service.onPost(url.plot_siswa_delete, body)                        
                        .then((resultDelete) => {
                            if (resultDelete) {
                                this.$swal(
                                    'Terhapus!',
                                    'Data berhasil dihapus.',
                                    'success'
                                )
                                this.getAllSiswaByPeriode()
                            }
                        })
                        // eslint-disable-next-line
                        .catch((errDelete) => {
                            this.$swal({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Terjadi Kesalahan!',
                            })
                        })
                    }
                })
            },
            editData(data, index) {                
                console.log(data, 'edit')
                this.$data.form_data.idtenant = this.tenant
                this.$data.form_data.idsiswa = data.idsiswa
                this.$data.form_data.idwalikelas = data.idwalikelas
                // this.$data.form_data.idkelas = data.Kelas.id
                this.$data.indexEdit = index
                // this.$bvModal.show('edit-modal')
            },
            handleSubmit(evt) {
                evt.preventDefault()
                if(this.selectedWaliKelas && this.selectedSiswa)
                {
                    this.form_data_result.idperiode = true
                    this.form_data_result.iduser = true
                    this.form_data_result.idkelas = true
                }
                else
                {
                    this.form_data_result.idperiode = false
                    this.form_data_result.iduser = false
                    this.form_data_result.idkelas = false
                }

                if (this.form_data_result.iduser && this.form_data_result.idkelas) {
                    this.loader = true;
                    // this.form_data.idtenant = this.tenant;
                    // let body = _.clone(this.form_data);

                    let body = { 
                        idtenant: this.tenant,
                        idsiswa: this.selectedSiswa,
                        idwalikelas: this.selectedWaliKelas
                    }
                    console.log(body);

                    service.onPost(url.siswakelas, body)
                    .then(result => {
                        setTimeout(() => {
                            this.loader = false;
                            this.$toasted.show(" Siswa kelas berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                        }, 1000);                        
                        console.log(result.data, "add data");
                        this.getAllSiswaByPeriode()
                        this.cancelAdd()					
                    }).catch(error => {
                        setTimeout(() => {
                            // eslint-disable-next-line
                            console.log(error);
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;
                        }, 1000);
                        this.cancelAdd()
                    })
                }
            },
            getWalikelasByPeriode() {
                let tenant = this.tenant
                service.onGet(`${url.plot_walikelas}/${this.allPeriode[0].id}/${tenant}`)
                .then((res) => {
                    this.dataUserWaliKelas = res.data
                    console.log(res.data)
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            async getAllData() {
                this.loader = true;
                const tenant = this.tenant
                try {
                    let periode = await service.onGet(`${url.periode_get_aktif_periode}/${tenant}`)                    
                    if (periode.data.length) {
                        this.allPeriode = periode.data                                                                         
                        let siswa = await service.onGet(`${url.master_siswa_get_by_tenant}/${tenant}`)
                        this.allSiswabyTenant = siswa.data
                        this.getAllSiswaByPeriode();
                        this.getWalikelasByPeriode();         
                        this.changeState(1)
                    } else {
                        this.changeState(0)
                    }
                    
                    
                    this.loader = false;
                } catch (error) {
                    console.log(error)
                    this.loader = false;
                }
            },
            getAllSiswaByPeriode(){
                this.loader = true;
                // service.onGet(url.master_get_user_walikelas + "/" + localStorage.getItem("idtenant"))
                let curPeriode = this.allPeriode[0].id
                service.onGet(`${url.plot_siswa}/${this.tenant}/${curPeriode}`)
                .then(result => {
                    console.log(result.data, 'plot siswa');
                    this.loader = false;
                    if (result.data) {
                        this.allWalikelas = result.data;
                        this.changeState(1)
                        //this.questions = JSON.parse(result.data.fullquestion);
                    }
                }).catch(error => {
                    this.loader = false;
                    console.log(error)
                })
            },
            resetForm() {                
                this.$data.form_data.idtenant = this.tenant
                this.$data.form_data.idsiswa = ''
                this.$data.form_data.idwalikelas = ''
                this.$data.form_data_result.idsiswa = null
                this.$data.form_data_result.idwalikelas = null
                this.$data.selectedSiswa = null
                this.$data.selectedPeriode = null
                this.$data.selectedWaliKelas = null
                this.$data.indexEdit = -1
            }
        },
        mounted() {
            this.tenant = localStorage.getItem("idtenant")
            //this.getAllSiswaByPeriode();
            this.getAllData()            
        },
        computed: {
            //
        }
    }
</script>
<style lang="scss" scoped>

</style>